<script setup>
import { inject, onMounted, ref } from 'vue'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import useFavorites from '@/Shared/useFavorites.js'
import ButtonFavoriteToggle from '@/Shared/Buttons/ButtonFavoriteToggle'

const data = inject('data')

const onClick = ref()

const props = defineProps({
  noFavorite: Boolean,
  brandV2: Boolean,
})

const getStorySlug = () => {
  if (!data.story_flag) return false
  if (typeof data.story_flag.akimamaSlug === 'undefined') return false
  return data.story_flag.akimamaSlug
}
onMounted(() => {
  const { updateFavoriteList } = useFavorites({ category: 'brand' })
  onClick.value = updateFavoriteList
})
</script>

<template>
  <ul class="btn-list grid gap-[15px]">
    <li v-if="props.brandV2"><ButtonRounded text="商品一覧" icon="arrow" url="#brand-products" /></li>
    <li v-if="getStorySlug()"><ButtonRounded text="ブランドストーリー" icon="arrow" :url="'/brandstory/' + getStorySlug()" /></li>
    <li><ButtonRounded text="取り扱い店舗" icon="arrow" :url="`/stores/finder?brand=${data.brandSlug}`" /></li>
    <!-- <li><ButtonRounded text="関連ニュース" icon="arrow" :url="'/news'" /></li> -->
    <li><ButtonRounded text="よくある質問" icon="arrow" :url="`/faq/brand/${data.brandSlug}`" /></li>
    <li v-if="data.localWebURL"><ButtonRounded text="ブランドサイト" icon="external" :url="data.localWebURL" /></li>
    <li v-if="data.localEcURL"><ButtonRounded text="オンラインストア" icon="external" :url="data.localEcURL" /></li>
    <li v-if="!props.noFavorite">
      <div class="btn-rounded" @click="(e) => onClick(e)">
        <div class="absolute top-1/2 -translate-y-1/2">お気に入り</div>
        <ButtonFavoriteToggle category="brand" :slug="data.brandSlug" class="relative z-10 w-full h-full [&_.af-icon]:!w-[12px] [&_.af-icon]:!h-[12px]" />
      </div>
    </li>
  </ul>
</template>
